// для TableSpecial, чтобы не расписывать объекты с пустыми mod
const map2mod = item => ({ data: item, mod: '' })

export {
  map2mod
}
